export enum DxAppRoutes {
  LOGIN_ROUTE = 'welcome',
  NAVIGATOR_ROUTE = 'navigator',
  ERROR_ROUTE = 'error',
}
